import { render } from "./CountryGroupCard.vue?vue&type=template&id=cbc8fe66"
import script from "./CountryGroupCard.vue?vue&type=script&lang=js"
export * from "./CountryGroupCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__